<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="col-sm-12 nopads">
        <Transition name="fade">
            <div
                v-if="tableItems.length > 0"
                class="col-sm-12 pb-2 result-table"
            >
                <vue3-datatable
                    ref="resultTable"
                    :rows="tableItems"
                    :columns="fields"
                    :pagination="false"
                    :sticky-header="true"
                    :height="tableItems.length > 5 ? '60vh' : '100%'"
                    :sortable="true"
                    :has-checkbox="true"
                    skin="bh-table-compact"
                    :row-class="getRowClass"
                    cell-class="routa-table-cell"
                    @row-click="emitEdit"
                    @row-select="rowSelected"
                >
                    <template #create_time="row">
                        {{ row.value.create_time_text }}
                    </template>
                    <template #has_geometries="row">
                        <div v-if="row.value.has_geometries" class="col-12 d-flex justify-content-center nopads" style="color: #7FC000">
                            <i class="fa fa-check"></i>
                        </div>
                    </template>
                </vue3-datatable>
            </div>
        </Transition>

        <base-modal v-if="showSelectedModal" @close="showSelectedModal = false">
            <template #header>{{ $t('orders.selected_orders') }} ({{ selectedTableItems.length }})</template>
            <div class="list-group">
                <div v-for="order in selectedTableItems" :key="order.id" class="list-group-item">
                    <strong>ID: {{ order.id }}</strong> - {{ order.tasktype }} - {{ order.status }}
                </div>
            </div>
            <template #footer>
                <button class="btn btn-secondary" @click="showSelectedModal = false">{{ $t('common.close') }}</button>
            </template>
        </base-modal>
    </div>
</template>

<script>
import {orderStatus, workManagementHelper} from '../mixins/WorkManagementMixin'
import {priceHelper} from "../mixins/PricingMixin";
import {timeUtils} from '../mixins/TimeUtils'
import {orderMixin} from "@/components/mixins/OrderMixin";
import Vue3Datatable from "@bhplugin/vue3-datatable";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import BaseModal from "../BaseModal.vue";

export default {
    name: 'OrderList',
    components: {FontAwesomeIcon, Vue3Datatable, BaseModal},
    mixins: [workManagementHelper, priceHelper, timeUtils, orderMixin],
    props: {
        results: {
            type: Array,
            default() {
                return []
            }
        },
        user: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            sortBy: 'tasktype',
            sortDesc: false,
            tableItems: [],
            selectedRowId: null,
            loading: false,
            selectedTableItems: [],
            showSelectedModal: false
        }
    },
    computed: {
        currency() {
            return import.meta.env.VITE_APP_CURRENCY || '€'
        },
        fields() {
            return [
                {field: 'id', title: 'Id', sort: true, headerClass: 'routa-table-header', type: 'number'},
                {field: 'tasktype', title: this.$t('orders.task_type'), sort: true, headerClass: 'routa-table-header'},
                {field: 'customer', title: this.$t('orders.customer'), sort: true, headerClass: 'routa-table-header'},
                {field: 'contract', title: this.$t('orders.contract'), sort: true, headerClass: 'routa-table-header'},
                {field: 'contractor', title: this.$t('orders.contractor'), sort: true, headerClass: 'routa-table-header'},
                {field: 'orderer', title: this.$t('orders.ordered_by'), sort: true, headerClass: 'routa-table-header'},
                {field: 'info', title: this.$t('orders.info'), sort: true, headerClass: 'routa-table-header', minWidth: '30em'},
                {field: 'executor', title: this.$t('orders.executor'), sort: true, headerClass: 'routa-table-header', minWidth: '10em'},
                {field: 'create_time', title: this.$t('orders.create_time'), sort: true, headerClass: 'routa-table-header'},
                {field: 'status', title: this.$t('orders.status'), sort: true, headerClass: 'routa-table-header'},
                {field: 'object_number', title: this.$t('orders.object'), sort: true, headerClass: 'routa-table-header'},
                {field: 'price', title: this.$t('orders.unit_price', {currency: this.currency}), sort: false, headerClass: 'routa-table-header'},
                {
                    field: 'has_geometries',
                    title: this.$t('orders.has_geometries'),
                    headerClass: 'routa-table-header',
                },
            ]
        }
    },
    mounted: function () {
        this.initTableItems()
    },
    watch: {
        results: function () {
            this.initTableItems()
        }
    },
    methods: {
        setSelection(index) {
            this.selectedRowId = null
            if (index >= 0 && index < this.results.length) {
                this.selectedRowId = this.results[index].id
            }
        },

        resetSelection() {
            this.selectedRowId = null
        },

        scrollToSelected() {
            if (this.selectedRowId) {
                const rowElement = document.querySelector(`.row-id-${this.selectedRowId}`)
                if (rowElement) {
                    rowElement.scrollIntoView({ behavior: 'auto', block: 'center' })
                } else {
                    this.selectedRowId = null
                }
            }
        },

        getRowClass(row) {
            switch (row.statusCode) {
                case orderStatus.OPEN: return 'routa-table-row open-row row-id-' + row.id
                case orderStatus.IN_PROGRESS: return 'routa-table-row selected-row row-id-' + row.id
                case orderStatus.COMPLETED: return 'routa-table-row completed-row row-id-' + row.id
                case orderStatus.CANCELLED: return 'routa-table-row cancelled-row row-id-' + row.id
                case orderStatus.PLAN: return 'routa-table-row planned-row row-id-' + row.id
                case orderStatus.STORED: return 'routa-table-row warning-row row-id-' + row.id
                case orderStatus.APPROVED: return 'routa-table-row approved-row row-id-' + row.id
                case orderStatus.INVOICED: return 'routa-table-row invoiced-row row-id-' + row.id
                case orderStatus.CLOSED: return 'routa-table-row expired-row row-id-' + row.id
                case orderStatus.ABORTED: return 'routa-table-row danger-row row-id-' + row.id
            }
            return 'routa-table-row'
        },

        initTableItems() {
            this.tableItems = []
            const temp = []
            if (this.results) {
                this.results.forEach(item => {
                    temp.push({
                        '_rowVariant': this.getStatusColorVariant(item.status),
                        'id': item.id,
                        'tasktype': item.contract_task_type ? item.contract_task_type.task_type.name : '',
                        'customer': item.contract_task_type ? item.contract_task_type.contract.customer.name : '',
                        'contract': item.contract_task_type ? item.contract_task_type.contract.name : '',
                        'contractor': item.contract_task_type ? item.contract_task_type.contract.contractor.name : '',
                        'orderer': item.created_by ? item.created_by.last_name + ' ' + item.created_by.first_name : '',
                        'info': item.info ? item.info.length > 200 ? item.info.substr(0, 200) + '...' : item.info : '',
                        'executor': this.getOrderExecutors(item),
                        'create_time': item.create_time ?? '',
                        'create_time_text': item.create_time ? this.toLocalTime(item.create_time) : '',
                        'status': item.status ? this.getStatusString(item.status) : '',
                        'statusCode': item.status,
                        'object_number': item.object_number,
                        'price': (item.unit_price && !item.price_list
                                ? (item.unit_price / 100).toFixed(3) + ' ' + this.currency + ' / '
                                : '') +
                            (item.price_list && item.pricing_model ? this.currency + ' / ' : '') +
                            (item.pricing_model ? this.unitToText(item.pricing_model.unit1) : '') +
                            (item.pricing_model && item.pricing_model.unit2 ? '/' + this.unitToText(item.pricing_model.unit2) : ''),
                        'has_geometries': item.has_geometries === true,
                    })
                })
            }
            this.$nextTick(() => {
                this.tableItems = temp
                this.$nextTick(() => this.scrollToSelected())
            })
        },
        canEdit: function (order) {
            return this.user.company.id === order.contract_task_type.contract.customer.id ||
                this.user.company.id === order.contract_task_type.contract.contractor.id
        },
        emitEdit: function (result) {
            let item = this.results.find(item => result.id === item.id)
            if (item) {
                this.selectedRowId = item.id
                this.$emit('edit', item)
            }
        },
        rowSelected: function (selectedRows) {
            this.selectedTableItems = selectedRows
            this.$emit('row-select', selectedRows)
        },
        clearSelection: function () {
            this.selectedTableItems = []
            if (this.$refs.resultTable) {
                this.$refs.resultTable.clearSelectedRows()
            }
        },
    },
}
</script>
